export function initThemeWidgetRepository() {
  console.log('@framework/theme-rer: initThemeWidgetRepository');
}
